import type { IBrazilianCompanyIssuerTopLevelFragment } from "lib/fragments/__generated__/BrazilianCompanyIssuerTopLevel.generated";
import * as palette from "../../palette";

interface IBrazilianCompanyIssuerFreeFloatProps {
  freeFloat: NonNullable<IBrazilianCompanyIssuerTopLevelFragment["freeFloat"]>;
}

export default function BrazilianCompanyIssuerFreeFloat({ freeFloat }: IBrazilianCompanyIssuerFreeFloatProps) {
  return (
    <div className="space-y-2 font-aeonik text-sm font-bold xl:text-sm">
      {freeFloat.percentageOfTotalSharesOfCommonStock > 0 && (
        <div
          aria-label={`${freeFloat.percentageOfTotalSharesOfCommonStock}% de Free Float nas ONs`}
          style={{
            color: freeFloat.percentageOfTotalSharesOfCommonStock < 25 ? palette.mojo : palette.oceanGreen,
          }}
        >
          {freeFloat.percentageOfTotalSharesOfCommonStock.toFixed(2).replace(".", ",")}% ON
        </div>
      )}

      {freeFloat.percentageOfTotalSharesOfPreferredStock > 0 && (
        <div
          aria-label={`${freeFloat.percentageOfTotalSharesOfPreferredStock.toFixed(2)}% de Free Float nas PNs`}
          style={{
            color: freeFloat.percentageOfTotalSharesOfPreferredStock < 25 ? palette.mojo : palette.oceanGreen,
          }}
        >
          {freeFloat.percentageOfTotalSharesOfPreferredStock.toFixed(2).replace(".", ",")}% PN
        </div>
      )}

      {freeFloat.percentageOfTotalSharesOfPreferredStock > 0 && (
        <div
          aria-label={`${freeFloat.percentageOfTotalShares.toFixed(2)}% de Free Float Total`}
          style={{
            color: freeFloat.percentageOfTotalShares < 25 ? palette.mojo : palette.oceanGreen,
          }}
        >
          {freeFloat.percentageOfTotalShares.toFixed(2).replace(".", ",")}% Total
        </div>
      )}
    </div>
  );
}
